import { useEffect, useState } from "react";
import * as yup from 'yup';
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useHandleForm = (allRows, data, createCallback, modifyCallback, invalidDataCallback) => {

  const dispatch = useDispatch();

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "number") {
        return isCreate ? "99" : data[fieldName];
      }

      if (fieldName === "moment") {
        return isCreate ? "SIN" : data[fieldName];
      }

      if (fieldName === "materials") {
        return isCreate ? [] : data[fieldName];
      }

      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = ["number", "name", "moment", "comment", "actionType", "materials", "activity"];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(() => createInitialData());

  useEffect(() => { // actualizar activity cuando cambia la data inicial desde afuera
    if (!data) return;
    setFormData((prev) => ({ ...prev, activity: data.activity }));
  }, [data])

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      name: yup.string().max(60).required(),
      moment: yup.string().max(6),
      comment: yup.string(),
      activity: yup.string(),
      actionType: yup.string().max(8).required(),
      materials: yup.array(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    const rowCoincidence = allRows.filter((detail) => detail.number !== data?.number && detail.name === formData?.name);
    if (rowCoincidence.length > 0) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("noDuplicateStepNames"), severity: 'error' }));
      return false;
    }

    if (await dataIsValid()) {
      let dataToSend = formData;

      if (!isCreate) {
        dataToSend.number = formData.number;
      }

      isCreate ? createCallback(dataToSend) : modifyCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (["moment", "actionType"].includes(fieldName) && formData.materials.length > 0) {
      dispatch(openDialogAction({
        title: getLocalizedString("atention"),
        msg: getLocalizedString("onboardingStepChangeWarning"),
        onConfirm: () => {
          setFormData((prev) => ({
            ...prev,
            [fieldName]: value,
            materials: [],
          }));
        },
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [fieldName]: value
    }))
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;
